import { Reveal } from '../hooks/useReveal'

export const About = ({ company }) => (
  <section className="section" id="about">
    <div className="container about__grid">
      <Reveal>
        <p className="eyebrow">About</p>
        <h2 className="section-title">
          Made end
          <br />
          to end.
        </h2>
      </Reveal>

      <Reveal delay={100} className="about__body">
        {company.about.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </Reveal>
    </div>
  </section>
)
